module.exports = __webpack_public_path__ + "static/media/2. Check update in support channel.04cb9c8a.svg";